export const PaymentMethod = {
    IOS_IAP: "ios_iap",
    ANDROID_IAP: "android_iap",
    CREDIT_CARD: "credit_card"
} as const;

export type PaymentMethod = typeof PaymentMethod[keyof typeof PaymentMethod];
